import { render, staticRenderFns } from "./AdminStandardEmbroideriesNewScreen.vue?vue&type=template&id=36bc89d2&scoped=true&"
import script from "./AdminStandardEmbroideriesNewScreen.vue?vue&type=script&lang=js&"
export * from "./AdminStandardEmbroideriesNewScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bc89d2",
  null
  
)

export default component.exports